$(function() {
        var tab = getParameterByName("type");

        //check selected tab
        // if (tab == 'sodai') {
        //     $('.trash-type-oversize').show();
        //     $('.trash-type-normal').hide();
        //     $('.select-trash-type-tab-left').removeClass('active');
        //     $('.select-trash-type-tab-right').addClass('active');
        // } else {
        //     $('.trash-type-oversize').hide();
        //     $('.trash-type-normal').show();
        //     $('.select-trash-type-tab-left').addClass('active');
        //     $('.select-trash-type-tab-right').removeClass('active');
        // }

        if (tab == 'sodai') {
            $('.trash-content-display').removeClass('d-none');
            $('.trash-type-oversize').hide();
            $('.trash-type-normal').show();
            $("a[data-link='trash-type-oversize']").removeClass('active');
            $("a[data-link='trash-type-normal']").addClass('active');

        } else {
            $('.trash-type-oversize').show();
            $('.trash-type-normal').hide();
            $("a[data-link='trash-type-oversize']").addClass('active');
            $("a[data-link='trash-type-normal']").removeClass('active');
        }

        //handle click tab
        $('.select-trash-type-tab').click(function () {
            $tabType = $(this).data('type');
            var str = window.location.search
            str = replaceQueryParam('type', $tabType, str)
            //window.location = window.location.pathname + str
            window.history.pushState({},"", window.location.pathname + str);

            $('.select-trash-type-tab').removeClass('active');
            $(this).addClass('active');
            $showContent = $(this).data('link');
            $('.trash-type-content').hide();
            $('.trash-type-content.' + $showContent).show();
        });

        $('.select-trash').click(function () {
            $tabType = $(this).data('type');
            var str = window.location.search
            str = replaceQueryParam('type', $tabType, str)
            //window.location = window.location.pathname + str
            window.history.pushState({},"", window.location.pathname + str);

            $showContent = $(this).data('link');
            $(".select-trash").find('a').removeClass('active');
            $("ul").find(`li[data-link='${$showContent}']`).find(`a[data-link='${$showContent}']`).addClass('active');        
            $('.trash-content-display').hide()
            $('.trash-content-display').removeClass('d-none');
            $('.trash-content-display.'+ $showContent).show();            
        });

        //handle sodai elements
        var oversizeInputs = $('.oversize-input');
        oversizeInputs.each(function(index) {
            var item = $(this);
            var itemValue = item.val();
            if (!itemValue || itemValue ==0) {
                item.prop('disabled', true);
            }
        });

        $('.oversize-checkbox').click(function () {
            $showInput = $(this).data('input');
            $showData = $(this).prop('checked');
            if ($showData) {
                $('.' + $showInput).parent().addClass('active');
                $('.' + $showInput).prop('disabled', false).val(1);
            } else {
                $('.' + $showInput).parent().removeClass('active');
                $('.' + $showInput).prop('disabled', true).val(0);
            }
        });

        $(document).on('click', '.form-input-adjustable.active', function (e) {
            $currentVal = parseInt($('.oversize-input', this).val());
            if (e.offsetX > e.target.offsetLeft) {
                if (e.offsetX > 86) {
                    //click plust button
                    $('.oversize-input', this).val($currentVal + 1);
                } else {
                    //click minus button
                    $resultMinus = $currentVal - 1 < 1 ? 1 : $currentVal - 1;
                    $('.oversize-input', this).val($resultMinus);
                }
            } else {
                //console.log('out')
            }
        });
        
        function getParameterByName(name) {
            name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
            var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
                results = regex.exec(location.search);
            return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
        }
        function replaceQueryParam(param, newval, search) {
            var regex = new RegExp("([?;&])" + param + "[^&;]*[;&]?");
            var query = search.replace(regex, "$1").replace(/&$/, '');

            return (query.length > 2 ? query + "&" : "?") + (newval ? param + "=" + newval : '');
        }
    
});
